'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { Pagination, PaginationContent, PaginationEllipsis, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious } from '@/components/ui/pagination';
import { useTranslations } from 'next-intl';
type PropsType = {
  currentPage?: number;
  totalPages?: number;
  className?: string;
  // When provided, page changes are reported via onPageChange instead of navigating (used by the
  // client-side products browser). The anchor href is still set so links stay crawlable/shareable.
  onPageChange?: (page: number) => void;
};
const ContentPagination = t0 => {
  const $ = _c(57);
  const {
    currentPage: t1,
    totalPages: t2,
    className: t3,
    onPageChange
  } = t0;
  const currentPage = t1 === undefined ? 1 : t1;
  const totalPages = t2 === undefined ? 1 : t2;
  const className = t3 === undefined ? "" : t3;
  const t = useTranslations();
  const pathname = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();
  if (totalPages <= 1) {
    return null;
  }
  let t4;
  if ($[0] !== pathname || $[1] !== searchParams) {
    t4 = page => {
      const params = new URLSearchParams(searchParams.toString());
      params.set("page", page.toString());
      return `${pathname}?${params.toString()}`;
    };
    $[0] = pathname;
    $[1] = searchParams;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const createPageUrl = t4;
  let t5;
  if ($[3] !== createPageUrl || $[4] !== onPageChange || $[5] !== router) {
    t5 = page_0 => {
      if (onPageChange) {
        onPageChange(page_0);
        return;
      }
      router.push(createPageUrl(page_0));
    };
    $[3] = createPageUrl;
    $[4] = onPageChange;
    $[5] = router;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const handlePageChange = t5;
  let t6;
  if ($[7] !== currentPage || $[8] !== totalPages) {
    t6 = () => {
      const pages = [];
      const showEllipsisStart = currentPage > 3;
      const showEllipsisEnd = currentPage < totalPages - 2;
      if (totalPages <= 7) {
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        if (showEllipsisStart) {
          pages.push("ellipsis");
        }
        const start = Math.max(2, currentPage - 1);
        const end = Math.min(totalPages - 1, currentPage + 1);
        for (let i_0 = start; i_0 <= end; i_0++) {
          pages.push(i_0);
        }
        if (showEllipsisEnd) {
          pages.push("ellipsis");
        }
        pages.push(totalPages);
      }
      return pages;
    };
    $[7] = currentPage;
    $[8] = totalPages;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const getPageNumbers = t6;
  let T0;
  let T1;
  let t7;
  let t8;
  let t9;
  if ($[10] !== className || $[11] !== createPageUrl || $[12] !== currentPage || $[13] !== getPageNumbers || $[14] !== handlePageChange || $[15] !== t) {
    const pageNumbers = getPageNumbers();
    T1 = Pagination;
    t9 = className;
    T0 = PaginationContent;
    const t10 = currentPage > 1 ? createPageUrl(currentPage - 1) : undefined;
    let t11;
    if ($[21] !== currentPage || $[22] !== handlePageChange) {
      t11 = e => {
        if (currentPage > 1) {
          e.preventDefault();
          handlePageChange(currentPage - 1);
        }
      };
      $[21] = currentPage;
      $[22] = handlePageChange;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    const t12 = currentPage === 1;
    const t13 = currentPage === 1 ? "pointer-events-none opacity-50" : "";
    let t14;
    if ($[24] !== t) {
      t14 = t("previous");
      $[24] = t;
      $[25] = t14;
    } else {
      t14 = $[25];
    }
    let t15;
    if ($[26] !== t14) {
      t15 = <span className="hidden sm:block">{t14}</span>;
      $[26] = t14;
      $[27] = t15;
    } else {
      t15 = $[27];
    }
    if ($[28] !== t10 || $[29] !== t11 || $[30] !== t12 || $[31] !== t13 || $[32] !== t15) {
      t7 = <PaginationItem><PaginationPrevious href={t10} onClick={t11} aria-disabled={t12} className={t13}>{t15}</PaginationPrevious></PaginationItem>;
      $[28] = t10;
      $[29] = t11;
      $[30] = t12;
      $[31] = t13;
      $[32] = t15;
      $[33] = t7;
    } else {
      t7 = $[33];
    }
    t8 = pageNumbers.map((pageNum, index) => {
      if (pageNum === "ellipsis") {
        return <PaginationItem key={`ellipsis-${index}`}><PaginationEllipsis /></PaginationItem>;
      }
      return <PaginationItem key={pageNum}><PaginationLink href={createPageUrl(pageNum)} onClick={e_0 => {
          e_0.preventDefault();
          handlePageChange(pageNum);
        }} isActive={currentPage === pageNum}>{pageNum}</PaginationLink></PaginationItem>;
    });
    $[10] = className;
    $[11] = createPageUrl;
    $[12] = currentPage;
    $[13] = getPageNumbers;
    $[14] = handlePageChange;
    $[15] = t;
    $[16] = T0;
    $[17] = T1;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    T0 = $[16];
    T1 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  const t10 = currentPage < totalPages ? createPageUrl(currentPage + 1) : undefined;
  let t11;
  if ($[34] !== currentPage || $[35] !== handlePageChange || $[36] !== totalPages) {
    t11 = e_1 => {
      if (currentPage < totalPages) {
        e_1.preventDefault();
        handlePageChange(currentPage + 1);
      }
    };
    $[34] = currentPage;
    $[35] = handlePageChange;
    $[36] = totalPages;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  const t12 = currentPage === totalPages;
  const t13 = currentPage === totalPages ? "pointer-events-none opacity-50" : "";
  let t14;
  if ($[38] !== t) {
    t14 = t("next");
    $[38] = t;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== t14) {
    t15 = <span className="hidden sm:block">{t14}</span>;
    $[40] = t14;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== t10 || $[43] !== t11 || $[44] !== t12 || $[45] !== t13 || $[46] !== t15) {
    t16 = <PaginationItem><PaginationNext href={t10} onClick={t11} aria-disabled={t12} className={t13}>{t15}</PaginationNext></PaginationItem>;
    $[42] = t10;
    $[43] = t11;
    $[44] = t12;
    $[45] = t13;
    $[46] = t15;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== T0 || $[49] !== t16 || $[50] !== t7 || $[51] !== t8) {
    t17 = <T0>{t7}{t8}{t16}</T0>;
    $[48] = T0;
    $[49] = t16;
    $[50] = t7;
    $[51] = t8;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] !== T1 || $[54] !== t17 || $[55] !== t9) {
    t18 = <T1 className={t9}>{t17}</T1>;
    $[53] = T1;
    $[54] = t17;
    $[55] = t9;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  return t18;
};
export default ContentPagination;